<template>
  <div class="d-flex justify-end" @click="$refs.theInput.focus()" @click.self="show">
    <v-text-field
      v-show="on"
      ref="theInput"
      v-model="search"
      class="pb-0 pt-0"
      color="lightGrey"
      height="22"
      hide-details
      @input="toSearch"
    />

    <v-btn
      text title="Поиск" class="ml-1 pa-0 px-2 text-lowercase"
      color="lightGrey"
      @click="show"
    >
      <span v-if="isXs && !on" class="mr-1"></span>
      <v-icon class="uikit-icon search" />
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SearchElement',

  components: {},

  props: {
    searchProps: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    on: false,
    search: '',
  }),

  computed: { ...mapGetters('breakpoint', ['isXs']) },

  methods: {
    show() {
      this.on = !this.on
    },

    toSearch() {
      this.$emit('update:searchProps', this.search)
    },
  },

  watch: {
    searchProps(val) {
      this.search = val
    },
  },
}
</script>

<style scoped lang="scss">
.search-input-border {
  padding: 1px 5px 1px 15px;
  border: 1px solid rgba(0,0,0,.38);
  border-radius: 24px;
}

.search-input-border:hover {
  border: 1px solid var(--lightGrey-color);
}
</style>
